import BaseComponent from '@/components/base';
import { getStyle, getCtaStyle } from '@/components/static-banner/style';
import { FontStyle } from '@/components/style';

const DEFAULT_BANNER_HEIGHT = 425;
const DEFAULT_CONTENT_PADDING = '0';

const DEFAULT_FONT_SIZE_TITLE = 50;
const DEFAULT_FONT_SIZE_TITLE_MOBILE = 36;
const DEFAULT_LINE_HEIGHT_TITLE = 50;
const DEFAULT_LINE_HEIGHT_TITLE_MOBILE = 40;

const DEFAULT_FONT_SIZE_DESCRIPTION = 16;
const DEFAULT_FONT_SIZE_DESCRIPTION_MOBILE = 14;
const DEFAULT_LINE_HEIGHT_DESCRIPTION = 22;
const DEFAULT_LINE_HEIGHT_DESCRIPTION_MOBILE = 22;

const DEFAULT_CTA_COLOR = '#ffffff';
const DEFAULT_CTA_BG_COLOR = '#000000';

const DEFAULT_VERTICAL_ALIGNMENT = 'center';
const DEFAULT_TEXT_ALIGNMENT = 'left';

export default class StaticBanner extends BaseComponent {
  get backgroundColor() {
    return this.getAttribute('background-color');
  }

  get eyebrowText() {
    return this.getAttribute('eyebrow-text');
  }

  get title() {
    return this.getAttribute('title');
  }

  get description() {
    return this.getAttribute('description');
  }

  get imageDesktop() {
    return this.getAttribute('image-desktop');
  }

  get imageMobile() {
    return this.getAttribute('image-mobile');
  }

  get fullWidth() {
    return this.getAttribute('full-width') === '';
  }

  get ctaText() {
    return this.getAttribute('cta-text');
  }

  get ctaLink() {
    return this.getAttribute('cta-link');
  }

  get isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  get ctaSettings() {
    const ctaSettingsParsed = this.getAttribute('cta-settings')
      ? JSON.parse(this.getAttribute('cta-settings'))
      : {};
    return {
      fontColor: ctaSettingsParsed?.fontColor || DEFAULT_CTA_COLOR,
      fontHoverColor: ctaSettingsParsed?.fontHoverColor || DEFAULT_CTA_COLOR,
      backgroundColor:
        ctaSettingsParsed?.backgroundColor || DEFAULT_CTA_BG_COLOR,
      backgroundHoverColor:
        ctaSettingsParsed?.backgroundHoverColor || DEFAULT_CTA_BG_COLOR,
      targetType: ctaSettingsParsed?.targetType || '_blank'
    };
  }

  get fontSettings() {
    const fontSettingsParsed = this.getAttribute('font-settings')
      ? JSON.parse(this.getAttribute('font-settings'))
      : {};
    return {
      desktop: {
        title: {
          size: `${
            fontSettingsParsed.desktop?.title?.size || DEFAULT_FONT_SIZE_TITLE
          }px`,
          lineHeight: `${
            fontSettingsParsed.desktop?.title?.lineHeight ||
            DEFAULT_LINE_HEIGHT_TITLE
          }px`
        },
        description: {
          size: `${
            fontSettingsParsed.desktop?.description?.size ||
            DEFAULT_FONT_SIZE_DESCRIPTION
          }px`,
          lineHeight: `${
            fontSettingsParsed.desktop?.description?.lineHeight ||
            DEFAULT_LINE_HEIGHT_DESCRIPTION
          }px`
        },
        textAlignment:
          fontSettingsParsed.desktop?.textAlignment || DEFAULT_TEXT_ALIGNMENT
      },
      mobile: {
        title: {
          size: `${
            fontSettingsParsed.mobile?.title?.size ||
            DEFAULT_FONT_SIZE_TITLE_MOBILE
          }px`,
          lineHeight: `${
            fontSettingsParsed.mobile?.title?.lineHeight ||
            DEFAULT_LINE_HEIGHT_TITLE_MOBILE
          }px`
        },
        description: {
          size: `${
            fontSettingsParsed.mobile?.description?.size ||
            DEFAULT_FONT_SIZE_DESCRIPTION_MOBILE
          }px`,
          lineHeight: `${
            fontSettingsParsed.mobile?.description?.lineHeight ||
            DEFAULT_LINE_HEIGHT_DESCRIPTION_MOBILE
          }px`
        },
        textAlignment:
          fontSettingsParsed.mobile?.textAlignment || DEFAULT_TEXT_ALIGNMENT
      }
    };
  }

  get layoutSettings() {
    const layoutSettingsParsed = this.getAttribute('layout-settings')
      ? JSON.parse(this.getAttribute('layout-settings'))
      : {};
    return {
      desktop: {
        bannerHeight:
          layoutSettingsParsed?.desktop?.bannerHeight || DEFAULT_BANNER_HEIGHT,
        verticalAlignment:
          layoutSettingsParsed?.desktop?.verticalAlignment ||
          DEFAULT_VERTICAL_ALIGNMENT,
        contentPadding:
          layoutSettingsParsed?.desktop?.contentPadding ||
          DEFAULT_CONTENT_PADDING
      },
      mobile: {
        bannerHeight:
          layoutSettingsParsed?.mobile?.bannerHeight || DEFAULT_BANNER_HEIGHT,
        verticalAlignment:
          layoutSettingsParsed?.mobile?.verticalAlignment ||
          DEFAULT_VERTICAL_ALIGNMENT,
        contentPadding:
          layoutSettingsParsed?.mobile?.contentPadding ||
          DEFAULT_CONTENT_PADDING
      }
    };
  }

  get hasAdditionalContent() {
    const slot = this.shadowRoot?.querySelector('slot');
    return slot && slot.assignedNodes().length > 1;
  }

  get style() {
    return getStyle({
      imageDesktop: this.imageDesktop,
      imageMobile: this.imageMobile,
      hasAdditionalContent: this.hasAdditionalContent,
      fontSettings: this.fontSettings,
      layoutSettings: this.layoutSettings
    });
  }

  get ctaStyle() {
    return getCtaStyle(this.ctaSettings);
  }

  render() {
    return `
    ${this.style}
    ${FontStyle}
    ${this.ctaStyle}
    <div class="wrapper ${this.fullWidth ? 'full-width' : ''}">
      <div class="banner-container">

        <div class="banner-inner-container">
          <div class="text-block">
            ${
              this.eyebrowText
                ? `<h3 class="eyebrow">${this.eyebrowText}</h3>`
                : ''
            }
            ${this.title ? `<h1 class="title">${this.title}</h1>` : ''}
            ${
              this.description
                ? `
              <div class="description">
                ${this.description}
              </div>
            `
                : ''
            }

            ${
              this.ctaText && this.ctaLink
                ? `
                 <a class="cta cta-link" href="${this.ctaLink}" target="${this.ctaSettings.targetType}">
                    ${this.ctaText}
                 </a>
                `
                : ''
            }

          </div>

          <div class="additional-banner-content">
            <slot></slot>
          </div>

        </div>

      </div>
    </div>
    `;
  }
}
